/**
 * Ryan O'Dowd
 * 2024-02-20
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Button from '@components/common/Button';
import EmptyScreen from '@components/common/EmptyScreen';
import {
  FRIENDS_ROUTE,
} from '@utils/store/actions';
import React from 'react';
import User from '@containers/Friends/User';
import WidgetBase from '@components/WidgetBase';
import getStyles from './styles';
import hooks from '@hooks';

const Friends = (props: FriendsProps) => {
  const navigation = hooks.useNavigation();
  const styles = hooks.useStyles(getStyles);
  const i18n = hooks.useI18n();

  const friends = hooks.useTypedSelector((state) => state.usersFollowing);
  const topFriends = friends.sort((a, b) => new Date(b.last_active).getTime() - new Date(a.last_active).getTime()).slice(0, 10); // @TODO: have config options in this widget to show most recent, top earning, or favorite friends

  return (
    <WidgetBase.Container
      layout={props.layout}
      cellSize={props.cellSize}
    >
      <WidgetBase.Header
        title={i18n('friends')}
        onPress={() => navigation.navigate(FRIENDS_ROUTE)}
      />
      <WidgetBase.Content
        noBackground={topFriends.length > 0}
      >
        {topFriends.length === 0
          ? (
            <EmptyScreen.Wrapper>
              <EmptyScreen.Text>{i18n('noFriendsAddedYet')}</EmptyScreen.Text>
              <Button
                mode='contained'
                theme={styles.colors.accent}
                onPress={() => navigation.navigate(FRIENDS_ROUTE, {
                  openTab: 'find',
                })}
              >
                {i18n('addFriends')}
              </Button>
            </EmptyScreen.Wrapper>
          ) : (
            topFriends.map((friend) => ( // @TODO: current user should be in this leaderboard list with a different border color
              <User
                key={friend.id}
                {...friend}
                isFollowing={true}
                dense={true}// @TODO: should we create a new component instead of using this prop?
              />
            ))
          )
        }
      </WidgetBase.Content>
    </WidgetBase.Container>
  );
};

class FriendsProps {
  layout: {
    x: number,
    y: number,
    w: number,
    h: number,
  }; // @TODO: type
  cellSize: number;
};

export default Friends;
